var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "nav-item",
      class: _vm.name != "Dashboard" ? "nav-item-margin" : "",
      attrs: { align: "center" }
    },
    [
      this.name != "New Event"
        ? _c(
            "router-link",
            { staticClass: "nav-link", attrs: { to: _vm.url } },
            [
              _c("Icon", {
                staticClass: "icon-size",
                attrs: { name: _vm.icon }
              }),
              _vm._v(" "),
              _vm.notifyNumber > 0
                ? _c("div", { staticClass: "wrapper-notify-number" }, [
                    _c("span", {
                      staticClass: "fa-stack",
                      class: _vm.renderClass,
                      attrs: { "data-count": _vm.notifyNumber }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "div",
                {
                  class:
                    _vm.eventStatus == "review" ||
                    _vm.eventStatus == "submitted"
                      ? "text-section"
                      : null
                },
                [
                  _vm.eventStatus !== "review" &&
                  _vm.eventStatus !== "submitted"
                    ? _c("span", { staticClass: "nav-font-size-big" }, [
                        _vm._v(_vm._s(_vm.name))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.eventStatus === "review"
                    ? _c("span", { staticClass: "nav-font-size-small" }, [
                        _vm._v(_vm._s(_vm.name))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.eventStatus === "submitted"
                    ? _c("span", { staticClass: "nav-font-size-small" }, [
                        _vm._v(_vm._s(_vm.name))
                      ])
                    : _vm._e(),
                  _c("br"),
                  _vm._v(" "),
                  _vm.eventStatus === "submitted"
                    ? _c("div", { staticClass: "nav-font-size-big" }, [
                        _vm._v("ADURO")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.eventStatus === "review"
                    ? _c(
                        "div",
                        { staticClass: "nav-font-size-big nav-ellipsis" },
                        [_vm._v(_vm._s(_vm.getClientName))]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass: "nav-item",
              on: {
                click: function($event) {
                  _vm.newEventClick()
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "nav-link" },
                [
                  _c("Icon", {
                    staticClass: "icon-size",
                    attrs: { name: _vm.icon }
                  }),
                  _vm._v(" "),
                  _vm.notifyNumber > 0
                    ? _c("div", { staticClass: "wrapper-notify-number" }, [
                        _c("span", {
                          staticClass: "fa-stack",
                          class: _vm.renderClass,
                          attrs: { "data-count": _vm.notifyNumber }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm.eventStatus !== "review" &&
                  _vm.eventStatus !== "submitted"
                    ? _c("span", { staticClass: "nav-font-size-big" }, [
                        _vm._v(_vm._s(_vm.name))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.eventStatus === "review"
                    ? _c("span", { staticClass: "nav-font-size-small" }, [
                        _vm._v(_vm._s(_vm.name))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.eventStatus === "submitted"
                    ? _c("span", { staticClass: "nav-font-size-small" }, [
                        _vm._v(_vm._s(_vm.name))
                      ])
                    : _vm._e(),
                  _c("br"),
                  _vm._v(" "),
                  _vm.eventStatus === "submitted"
                    ? _c("span", { staticClass: "nav-font-size-big" }, [
                        _vm._v("ADURO")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.eventStatus === "review"
                    ? _c("span", { staticClass: "nav-font-size-big" }, [
                        _vm._v(_vm._s(_vm.getClientName))
                      ])
                    : _vm._e()
                ],
                1
              )
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7bfa3c92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bfa3c92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/SidebarNavIcons.vue
// module id = 1560
// module chunks = 1